import './entry_common';
import './js/geo-location';
import { reactOnCms } from 'common/js/react_on_cms';
import GridGallery from 'sealink/js/grid_gallery';
import BlogPostCard from 'sealink/react-components/blog-post-card';
import CardsFilter from 'sealink/react-components/cards-filter';
import CarouselGallery from 'sealink/react-components/carousel-gallery';
import CategoryCard from 'sealink/react-components/category-card';
import CategoryCardsCarousel from 'sealink/react-components/category-cards-carousel';
import EventCard from 'sealink/react-components/event-card';
import EventFilter from 'sealink/react-components/event-filter';
import ExperienceCard from 'sealink/react-components/experience-card';
import ExperienceFilter from 'sealink/react-components/experience-filter';
import GiftVouchers from 'sealink/react-components/gift-vouchers';
import NewsCardsCarousel from 'sealink/react-components/news-cards-carousel';
import RelatedEntriesCarousel from 'sealink/react-components/related-entries-carousel';
import { ConnectedExperience as Experience } from 'components/experience';
import Video from 'components/video';
import { BookingManagementWrapper as ManageBooking } from 'tenants/sealink/booking_management';
import FerryTimetable from 'tenants/sealink/ferry_timetable';

reactOnCms.register({
  ManageBooking,
  Experience,
  CarouselGallery,
  RelatedEntriesCarousel,
  GridGallery,
  Video,
  CategoryCard,
  BlogPostCard,
  EventCard,
  EventFilter,
  ExperienceCard,
  ExperienceFilter,
  GiftVouchers,
  NewsCardsCarousel,
  CategoryCardsCarousel,
  CardsFilter,
  FerryTimetable,
});
